const ChangeGroup = () => {
    return (
        <>
            <p className='Help__Subtitle'>Filtros</p>
            <p>¿Cómo funcionan los filtros?</p>
            <img src='/img/support/help/instructor/change_group/2.png' className='Help__Image' />
            <p><span className='Help__Text--Highlight'>Selecciona un grupo</span></p>
            <p>Muestra la lista de grupos registrados para elegir el que deseas gestionar.</p>
            <p><span className='Help__Text--Highlight'>Mostrar Ztudiantes</span></p>
            <p>Permite visualizar la lista de Ztudiantes del grupo seleccionado en formato de tabla, con datos básicos para identificarlos.</p>
            <p><span className='Help__Text--Highlight'>¿A qué grupo deseas moverlos?</span></p>
            <p>Permite seleccionar el grupo de destino al que se moverán los Ztudiantes marcados.</p>

            <p className='Help__Subtitle'>Buscar</p>
            <img src='/img/support/help/instructor/change_group/3.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Buscar</span>?</p>
            <p>Permite localizar rápidamente un Ztudiante por nombre o usuario. Escribe el dato en el campo de búsqueda y Ztudia mostrará solo los resultados relacionados, ocultando los demás para facilitar la gestión.</p>
            
            <p className='Help__Subtitle'>Listado de Ztudiantes</p>
            <img src='/img/support/help/instructor/change_group/4.png' className='Help__Image' />
            <p>¿Cómo funciona el listado de Ztudiantes?</p>
            <p>Una vez aplicados los filtros, Ztudia muestra una lista de Ztudiantes con datos básicos como nombre, apellidos y usuario. En cada fila aparece el botón Mover ahora, que permite trasladar al Ztudiante al grupo seleccionado como destino. Es posible marcar varios Ztudiantes para moverlos de manera simultánea, agilizando la gestión de grupos.</p>

            <p className='Help__Subtitle'>Mover ahora</p>
            <img src='/img/support/help/instructor/change_group/5.png' className='Help__Image' />
            <p>¿Cómo funciona la opción Mover ahora?</p>
            <p>Permite trasladar al Ztudiante seleccionado al grupo de destino definido en el filtro. Al hacer clic en este botón, Ztudia actualiza la asignación del alumno de manera inmediata, reflejando el cambio en la lista correspondiente.</p>
            <p>Esta acción puede realizarse de forma individual desde cada fila o en conjunto si se han marcado varios Ztudiantes para moverlos simultáneamente.</p>
        </>
    )
}

export { ChangeGroup };